import React from 'react'
import { FormattedRelativeTime, FormattedDate } from 'react-intl'
import { selectRelativeUnits } from '../../react-intl-helpers'
import { Tooltip } from '@contrast-security-inc/design-system-popovers'

export function ReceivedTimeCell({
  rowData: { received }
}: {
  rowData: {
    received: string
  }
}) {
  const { value, unit } = selectRelativeUnits(new Date(received))

  return (
    <Tooltip body={<FormattedRelativeTime value={value} unit={unit} />}>
      <span>
        <FormattedDate
          value={received}
          {...{
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          }}
        />
      </span>
    </Tooltip>
  )
}
